import {Component, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ModalComponent} from "@pb-labs/modal";
import {ButtonType} from "@pb-labs/button";
import {deleteVerificationModalActions} from "./const";
import {DeleteVerificationModalService} from "./delete-verification-modal.service";

@Component({
  selector: "app-delete-verification-modal",
  templateUrl: "./delete-verification-modal.component.html",
  styleUrls: ["./delete-verification-modal.component.scss"],
})
export class DeleteVerificationModalComponent implements OnInit, OnDestroy {
  @Input() message: string;
  @ViewChild("modal") modal: ModalComponent;

  readonly deleteVerificationModalActions = deleteVerificationModalActions;
  readonly buttonType = ButtonType;

  private destroy: Subject<void> = new Subject<void>();

  constructor(private deleteVerificationModalService: DeleteVerificationModalService) {}

  ngOnInit(): void {
    this.deleteVerificationModalService
      .open$()
      .pipe(takeUntil(this.destroy))
      .subscribe((message: string) => {
        this.message = message;
        this.modal.open();
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();

    this.message = null;
  }

  onButtonClick(action: deleteVerificationModalActions): void {
    this.modal.close();
    this.deleteVerificationModalService.verify(action);
  }
}
